var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{attrs:{"size":_vm.size,"type":_vm.colorType,"icon":_vm.iconType,"disabled":_vm.isDisabled},on:{"click":_vm.handleClick}},[_vm._v("\n  "+_vm._s(_vm.languageText)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5227310c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/button/BasicButton.vue
// module id = 577
// module chunks = 36